<template>
  <div class="footer" :class="{ ['footer--' + lang]: true }">
    <div class="footer__container" v-view="viewHandler">
      <!-- <div class="footer__headline">
        <h1>{{ getText("footer_headline") }}</h1>
        <h3>{{ getText("footer_hash") }}</h3>
      </div> -->
       
      <!-- <div class="footer__row footer__row--first">
        <span>{{ getText("footer_legal") }}</span>
      </div> -->

      <div class="footer__row footer__row--first">
        <span>{{ getText("footer_block_1") }}</span>
        <span>{{ getText("footer_block_2") }}</span>
        <span><a href="mailto:media@uaepavilionexpo.com?">{{ getText("footer_email") }}
        </a></span>
      </div>

      <!-- <div class="footer__row">
       <a href="https://www.youtube.com/channel/UCLA03CfIOIp55sNiI4k1tHA" target="_blank">
          <inline-svg :src="require('@/assets/svg/social_yt.svg')" />
        </a>
        <a href="https://www.facebook.com/uaeatexpo/" target="_blank">
          <inline-svg :src="require('@/assets/svg/social_facebook.svg')" />
        </a>
        <a href="https://www.instagram.com/uaeatexpo/" target="_blank">
          <inline-svg :src="require('@/assets/svg/social_insta.svg')" />
        </a>
        <a href="https://twitter.com/uaeatexpo/" target="_blank">
          <inline-svg :src="require('@/assets/svg/social_twitter.svg')" />
        </a>
      </div> -->

      <div class="footer__row footer__row--last">
        <span
          ><a href="http://www.uae.com" target="_blank">{{
            getText("footer_copyrights")
          }}</a></span
        >
      </div>
    </div>
  </div>
</template>

<script>
//import gsap from "gsap";
import ContentMixin from "@/mixins/ContentMixin";
export default {
  name: "Footer",
  mixins: [ContentMixin],
  props: { msg: String },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    viewHandler(e) {
      if (e.type === "enter") {
        //gsap.to(this.$el, { duration: 0.5, autoAlpha: 1 });
        //gsap.to(this.$el, { ease: "Expo.easeOut", y: 0, duration: 1 });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      //gsap.set(this.$el, { autoAlpha: 0 });
      //gsap.set(this.$el, { y: 100 });
    });
  },
};
</script>
